import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import Slider from "react-slick";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { Link, useLocation } from "react-router-dom";

const AboutUs = () => {
  ChangeTitle("About Us");
  const location = useLocation();
  const [leaderList, setLeaderList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [profileList, setProfileList] = useState([]);

  //   [
  //   {
  //     _id: "6753fa4a227fa147a13d4306",
  //     profileImage:
  //       "https://web.xpertlab.com/camel/api/gcclaw/images/1737716107951blob",
  //     fullName: "Mrs. Bhavika Jawaharani",
  //     description:
  //       '<ul><li style="line-height: 1.5;">Computer Engineer with 12+ years of experience in Data Analysis, Software\r\ndevelopment, Corporate training, and Teaching.</li><li style="line-height: 1.5;">Qualified as a Bachelor of Engineering, ACL Certified Data Analyst, Certified Ethical\r\nHacker (EC-Council), Microsoft Certified System Engineer (Microsoft Corporation),\r\nand Cisco Certified Network Associate (CISCO).</li><li style="line-height: 1.5;">Technology Specialization - Audit Command Language, Structure Query Language,\r\nDatabase, SAS</li><li style="line-height: 1.5;">Industries/Domain - Manufacturing, Banking, Insurance, Oil and Gas, Retail,\r\nDistribution, Automobile and FMCG.</li><li style="line-height: 1.5;">Analytics project on ERP - SAP, Oracle, BAAN, Microsoft Dynamics, and Life Asia</li></ul><br>',
  //     type: "leader",
  //   },
  //   {
  //     _id: "675409ea227fa147a13d4331",
  //     profileImage:
  //       "https://web.xpertlab.com/camel/api/gcclaw/images/1735817377627blob",
  //     fullName: "Mr. Ronak Saraogi",
  //     description:
  //       '<p>Ronak Saraogi offers expertise in Internal Audit, Fraud Investigations, Statutory Audit,\r\nCompliance, Data Analytics, Business Automation Processes, and Product Development.</p><p>With a strong background in insurance, manufacturing, and banking. He has successfully\r\nimplemented strategies to enhance operational efficiency and ensure regulatory compliance.</p><p>He is a qualified Chartered Accountant with a Diploma in Information Systems Audit (DISA\r\nICAI) and a postgraduate degree in Accountancy and Business Statistics (ABST).</p><p><span style="color: rgb(201, 153, 48);">Highlights:</span></p><p><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">- 5+ years of professional experience in Internal Audit and Compliance.</span></p><p><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">-&nbsp;Skilled in Fraud Investigations and Data Analytics.</span></p><p><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">-&nbsp;Proven track record in Business Automation and Product Development.</span></p><p><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">-&nbsp;Domain experience in Insurance, Manufacturing, and Banking.</span></p><p><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">-&nbsp;Committed to delivering value through innovative audit solutions and best practices.</span></p>',
  //     type: "team",
  //   },
  // ]

  // Profile API Call
  const viewProfileList = async () => {
    const param = {
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };
    var response = await postData("profile/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      // console.log(data,"DDDDDDDDDDDDDDDDDD");

      setProfileList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // console.log("response", profileList.length);
  // Leaders API Call
  const viewLeaderList = async () => {
    const param = {
      type: "leader",
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };
    var response = await postData(
      "advisoryleaderandteam/list",
      param,
      apiHeader(false),
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setLeaderList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Teams API Call
  const viewTeamList = async () => {
    const param = {
      type: "team",
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };
    var response = await postData(
      "advisoryleaderandteam/list",
      param,
      apiHeader(false),
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setTeamList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewProfileList();
    viewLeaderList();
    viewTeamList();
  }, []);

  // Slider Settings
  const leaderSettings = {
    slidesPerRow: 1,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    // autoplay: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const teamSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    // autoplay: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const profileSettings = {
    slidesPerRow: 1,
    slidesToShow: profileList?.length === 1 ? 1 : 2,
    slidesToScroll: 1,
    infinite: profileList?.length > 1, // Only enable infinite when more than 1 item
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: profileList?.length === 1 ? 1 : 2,
          slidesToScroll: 1,
          infinite: profileList?.length > 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: profileList?.length === 1 ? 1 : 2,
          slidesToScroll: 1,
          infinite: profileList?.length > 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: profileList?.length > 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">About us</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full">
            <div className="mb-[5%] legal-gcc-logo">
              <img
                className="w-[150px] h-[150px] mb-[1rem] mx-auto"
                src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
                alt=""
              />
              <p className="lg:w-[70%] mx-auto text-center legal-text-fs legal-text-b">
                At GCC Law Help, we are dedicated to providing accessible,
                accurate, and compassionate legal assistance to individuals who
                need it most. Our mission is to empower you with the knowledge
                and resources necessary to navigate the complexities of the
                legal system confidently and efficiently.
              </p>
            </div>
            {/* Vision & Mission */}
            <div id="visionmission" className="legal-vision-mission">
              <div className="w-full ml-auto relative legal-v-m-img">
                <div className="flex flex-col lg:flex-row gap-[3rem] lg:gap-[5rem] w-full relative z-[2] p-[5%] legal-vm-boxs">
                  <div className="lg:w-[50%] p-[3%] legal-vm-box">
                    <div className="mb-[5%] flex items-center gap-5">
                      <img
                        className="w-[15%]"
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/aboutus-vision.svg",
                        )}
                        alt=""
                      />
                      <h1 className="legal-vm-title hanson">Vision</h1>
                    </div>
                    <div>
                      <ol className="px-[6%] legal-ol-num-g">
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Comprehensive coverage - include all relevant tax
                          types in GCC countries (Corporate tax, VAT, customs
                          duties, etc.).
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Accessibility - provide content in english and arabic
                          for various users (individuals, SMEs, corporations),
                          compatible with web and mobile devices.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Accuracy and timeliness - ensure current information
                          with the latest laws and regulations.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Ease of understanding - use clear language, visual
                          aids, and practical examples.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Promotion of compliance - encourage tax compliance to
                          stabilize the GCC tax system.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Support for economic growth - help users make informed
                          decisions to boost GCC economic development.
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="h-auto lg:w-[50%] p-[5%] legal-vm-box">
                    <div className="mb-[5%] flex items-center gap-5">
                      <img
                        className="w-[15%]"
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/aboutus-mission.svg",
                        )}
                        alt=""
                      />
                      <h1 className="legal-vm-title hanson">Mission</h1>
                    </div>
                    <div>
                      <ol className="px-[6%] legal-ol-num-g">
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Provide the most authentic and fastest reporting of
                          information.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          Number 1 source for everything on tax and corporate
                          laws of GCC
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          To be a trusted partner of entities, professionals,
                          government, and students.
                        </li>
                        <li className="mb-[1rem] legal-ol-num-g-li">
                          To continuously improve, innovate in, and expand the
                          resources/services.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Profile */}
            <div id="profile" className="pt-[5%] advisory-team">
              <div className="at-part">
                <div className="w-full">
                  <h1 className="hanson text-center mb-[1%] ap6-h1 at-h1">
                    Profile
                  </h1>
                  <img
                    className="mb-[2%] mx-auto"
                    src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                    alt=""
                  />
                </div>
                <Slider
                  key={profileList.length}
                  {...profileSettings}
                  className="w-full lg:w-[80%] mx-auto flex lg:flex-row flex-col gap-[15vw] lg:gap-20 at-boxs"
                >
                  {profileList.map((data, i) => (
                    <div className="relative z-[2] px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] h-max al-box at-box">
                      <img
                        className="absolute ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                        src={data.profileImage}
                        alt=""
                      />
                      <h1 className="mb-[5%] hanson alb-name">
                        {data.fullName}
                      </h1>
                      <div
                        className="mb-[3%] alb-desc"
                        dangerouslySetInnerHTML={{
                          __html: data.description,
                        }}
                      />
                      {data.socialLink && (
                        <a
                          target="_blank"
                          href={data.socialLink}
                          className="flex items-center gap-3 alb-link"
                        >
                          <img
                            className="w-[2rem]"
                            src={toAbsoluteUrl(
                              "media/img/icon/social-media/Linkedin2.svg",
                            )}
                            alt=""
                          />
                          <span>{data.socialLink}</span>
                        </a>
                      )}
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            {/* Leaders Teams */}
            <div className="pt-[5%] advisory-leaders">
              <div className="w-full ml-auto relative al-bg-img">
                <div className="w-full relative z-[2] top-0 py-[4%]">
                  <div className="w-full">
                    <h1 className="hanson text-center mb-[1%] ap6-h1 al-h1">
                      Our leaders
                    </h1>
                    <img
                      className="mb-[2%] mx-auto"
                      src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                      alt=""
                    />
                  </div>
                  <Slider
                    {...leaderSettings}
                    className="w-full md:w-[90%] lg:w-[80%] xl:w-[70%] flex md:flex-row flex-col gap-[15vw] md:gap-20 al-boxs"
                  >
                    {leaderList.map((data, i) => (
                      <div className="relative z-[2] w-full mx-auto md:mx-0 px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] al-box">
                        <img
                          className="absolute z-[5] ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                          src={data.profileImage}
                          alt=""
                        />
                        <h1 className="mb-[5%] hanson alb-name">
                          {data.fullName}
                        </h1>
                        <p
                          className="mb-[3%] !h-max alb-desc"
                          dangerouslySetInnerHTML={{
                            __html: data.description,
                          }}
                        />
                        {data.socialLink && (
                          <a
                            target="_blank"
                            href={data.socialLink}
                            className="flex items-center gap-3 alb-link"
                          >
                            <img
                              className="w-[2rem]"
                              src={toAbsoluteUrl(
                                "media/img/icon/social-media/Linkedin2.svg",
                              )}
                              alt=""
                            />
                            <span>{data.socialLink}</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
            <div className="pt-[5%] advisory-team">
              <div className="at-part">
                <div className="w-full">
                  <h1 className="hanson text-center mb-[1%] ap6-h1 at-h1">
                    Our research and advisory team
                  </h1>
                  <img
                    className="mb-[2%] mx-auto"
                    src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                    alt=""
                  />
                </div>
                <Slider
                  {...teamSettings}
                  className="w-full flex lg:flex-row flex-col gap-[15vw] lg:gap-20 at-boxs"
                >
                  {teamList.map((data, i) => (
                    <div className="relative z-[2] px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] h-max al-box at-box">
                      <img
                        className="absolute ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                        src={data.profileImage}
                        alt=""
                      />
                      <h1 className="mb-[5%] hanson alb-name">
                        {data.fullName}
                      </h1>
                      <div
                        className="mb-[3%] alb-desc"
                        dangerouslySetInnerHTML={{
                          __html: data.description,
                        }}
                      />
                      {data.socialLink && (
                        <a
                          target="_blank"
                          href={data.socialLink}
                          className="flex items-center gap-3 alb-link"
                        >
                          <img
                            className="w-[2rem]"
                            src={toAbsoluteUrl(
                              "media/img/icon/social-media/Linkedin2.svg",
                            )}
                            alt=""
                          />
                          <span>{data.socialLink}</span>
                        </a>
                      )}
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
